import { useState } from "react";
import { CameraIcon } from "@radix-ui/react-icons";
import BarcodeScanner from "react-qr-barcode-scanner";

type BagBarcodeInputProps = {
  value?: string;
  onChange?: (value: string) => void;
  onScan?: (value: string) => void;
};

export default function BagBarcodeInput({
  value,
  onChange,
  onScan,
}: BagBarcodeInputProps) {
  const [localValue, setLocalValue] = useState("");
  const [openScanner, setOpenScanner] = useState(false);
  const inputValue = value ?? localValue;

  const setValue = (nextValue: string) => {
    if (onChange) {
      onChange(nextValue);
      return;
    }
    setLocalValue(nextValue);
  };

  return (
    <>
      <label className="block text-md font-medium text-gray-800 mb-2">
        Bag Number
      </label>

      <div className="relative mb-3">
        <input
          type="text"
          placeholder="Enter your Bag Number"
          value={inputValue}
          onChange={(e) => setValue(e.target.value)}
          className="w-full bg-gray-100 rounded-xl px-4 py-4 pr-12 text-gray-700 outline-none border-none"
        />

        {/* <button
          type="button"
          onClick={() => setOpenScanner(true)}
          className="
    absolute right-4 top-1/2 -translate-y-1/2
    h-8 w-8
    flex items-center justify-center
    rounded-full
    text-primary
    border
    border-primary
    
    hover:bg-gray-200 hover:text-gray-900
    transition
    focus:outline-none focus:ring-2 focus:ring-gray-300
  "
        >
          <CameraIcon className="h-4 w-4" />
        </button> */}
      </div>

      {/* Scanner Modal */}
      {/* {openScanner && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-4 w-[90%] max-w-sm">
            <BarcodeScanner
              width={300}
              height={300}
              onUpdate={(err: unknown, result: any) => {
                if (result) {
                  const scannedValue = result.text;
                  setValue(scannedValue);
                  onScan?.(scannedValue);
                  setOpenScanner(false);
                  console.log("result");
                  console.log(result);
                }
              }}
            />

            <button
              onClick={() => setOpenScanner(false)}
              className="mt-4 w-full bg-gray-200 rounded-lg py-2"
            >
              Cancel
            </button>
          </div>
        </div>
      )} */}
    </>
  );
}
